/** Handle slideshow */
class Slideshow {
  constructor(sectionId, settings) {
    this.sectionId = sectionId;
    this.section = document.getElementById(`shopify-section-${sectionId}`);
    this.slideshowElement = this.section?.querySelector('[data-lqfy-slideshow]');
    this.settings = settings;
    this.slideshowControls = this.section?.querySelector('[data-lqfy-slideshow-pagination]');
    this.slideshow = null;
  }
  initSlideshow() {
    if (!this.slideshowElement) return;
    let slideshowOptions = {
      initialSlide: this.settings.initialSlide,
      spaceBetween: -100,
      slidesPerView: 1.1,
      slidesPerGroup: 1,
      centeredSlides: true,
      autoHeight: true,
      loop: false,
      a11y: {
        enabled: true,
      },
      breakpoints: {
        [989]: {
          spaceBetween: -500,
          slidesPerView: this.settings.slidesPerView,
          slidesPerGroup: this.settings.slidesPerGroup,
        },
      },
    };
    slideshowOptions.autoplay = {
      delay: 10000,
      pauseOnMouseEnter: true,
    };
    if (this.slideshowControls) {
      slideshowOptions.pagination = {
        el: this.slideshowControls,
        type: 'bullets',
        dynamicBullets: false,
        clickable: false,
      };
    }
    this.slideshow = new Swiper(this.slideshowElement, slideshowOptions);
  }
  getCurrentSlide() {
    if (this.slideshow) {
      return this.slideshow.activeIndex;
    } else {
      return 0;
    }
  }
  init() {
    this.initSlideshow();
  }
  destroy() {
    if (this.slideshow) {
      this.slideshow = null;
    }
  }
}